import axios from "axios";
import { parseISO } from "date-fns";
import Decimal from "decimal.js";
import { z } from "zod";
import { environment } from "../../../environment";
import { errorLog } from "../../../logger";
import { Cusip, Custodian, CustodianAccountId, Ticker, } from "../../Types";
import ValidationError from "../../ZodError";
export const PQSClientOrderId = z.string().brand("PQSClientOrderId");
export const BlockId = z.string().brand("BlockId");
export const OrderTypeList = ["Market"];
export const OrderType = z.enum(OrderTypeList);
export const OrderSideList = ["Buy", "Sell"];
export const OrderSide = z.enum(OrderSideList);
export const pqsAssetClassOptions = ["Equity", "Mutual Fund"];
export const PQSAssetClass = z.enum(pqsAssetClassOptions);
export const StagedOrder = z.object({
    clientOrderId: PQSClientOrderId,
    blockId: BlockId,
    tradingSessionDate: z
        .string()
        .datetime()
        .transform((v) => parseISO(v)),
    custodianAccountId: CustodianAccountId,
    ticker: Ticker,
    cusip: Cusip,
    quantity: z.string().transform((v) => new Decimal(v)),
    orderType: OrderType,
    side: OrderSide,
    price: z.string().transform((v) => new Decimal(v)),
    tradeDate: z.string(),
    custodian: Custodian,
    creatorName: z.string(),
    traderName: z.string(),
    assetClass: PQSAssetClass,
});
const ResponseSchema = z.object({
    data: z.object({
        totalCount: z.string().transform((v) => new Decimal(v)),
        orders: StagedOrder.array(),
    }),
});
export const url = () => {
    return environment() === "PROD"
        ? `https://middleware.prod.farther.com/investment/trade-engine/staging`
        : `https://middleware.uat.farther.com/investment/trade-engine/staging`;
};
export const getStagedOrders = async (config) => {
    const { data } = await axios.get(url(), {
        headers: {
            version: "20241121",
            Authorization: `Bearer ${config.jwt}`,
            ...("advisorId" in config && { Advisor: config.advisorId }),
        },
    });
    const decoded = ResponseSchema.safeParse(data);
    if (decoded.success) {
        return decoded.data.data;
    }
    else {
        const errorMessage = `[${getStagedOrders.name}] received unexpected data`;
        errorLog(errorMessage, decoded.error.message);
        throw new ValidationError(errorMessage, decoded.error.issues);
    }
};
//# sourceMappingURL=getStagedOrders.js.map